import AXIOS from "@/axios";
import { APIResponse, DashboardData } from "@/types";
import { SchoolOption } from "@/types/school.model";
import { SchoolDashboardData } from "@/types/school-dashboard.model";
import { StudentDashboardData } from "@/types/student-dashboard.model";
import { TeacherDashboardData } from "@/types/teacher-dashboard.model";
import { StudentAssignmentData } from "@/types/assignment.model";
import { StudentClassDashboardData } from "@/types/student-class-dashboard.model";

export const getDashboardDataService = async () => {
  return AXIOS.get<APIResponse<DashboardData>>("/sch/api/v1/adm/dash");
};

export const getSchoolOptionsService = async () => {
  return AXIOS.get<APIResponse<SchoolOption[]>>("/base/api/v1/dp/sch/list");
};

export const getSchoolDashboardDataService = async (schoolId?: string) => {
  const url = schoolId ? `/sch/api/v1/dash?school_id=${schoolId}` : "/sch/api/v1/dash";
  return AXIOS.get<APIResponse<SchoolDashboardData>>(url);
};

export const getTeacherDashboardDataService = async (submissionDate?: string) => {
  const url = submissionDate 
    ? `/tch/api/v1/dash?subDate=${submissionDate}` 
    : "/tch/api/v1/dash";
  return AXIOS.get<APIResponse<TeacherDashboardData>>(url);
};

export const getStudentDashboardDataService = async () => {
  return AXIOS.get<APIResponse<StudentDashboardData>>("/stdnt/api/v1/dash");
};

export const getStudentClassDashboardDataService = async () => {
  return AXIOS.get<APIResponse<StudentClassDashboardData>>(
    "/stdnt/api/v1/class-dashboard"
  );
};

export const getStudentAssignmentsService = async (page: number = 1, pageSize: number = 10) => {
  return AXIOS.get<APIResponse<StudentAssignmentData>>(`/stdnt/api/v1/asgmt?page=${page}&pageSize=${pageSize}`);
};

export const getStudentClassAssignmentsService = async (
  page: number = 1,
  pageSize: number = 10
) => {
  return AXIOS.get<APIResponse<StudentAssignmentData>>("/stdnt/api/v1/asgmt", {
    params: {
      page,
      pageSize,
      recordType: "class",
      showAll: true,
    },
  });
};
